"use client";

import { useLocation } from "react-router-dom";
import ErrorReporter from "@/components/ErrorReporter";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const location = useLocation();
  const isLoginRoute = location.pathname === "/login" || location.pathname === "/staff/login";
  const isReceiptRoute = location.pathname.startsWith("/receipt/");

  // Only render AppProvider for non-login and non-receipt routes to prevent API calls on public pages
  if (isLoginRoute || isReceiptRoute) {
    return (
      <>
        <ErrorReporter />
        {children}
        <Toaster />
      </>
    );
  }

  return (
    <>
      <ErrorReporter />
      <AppProvider>
        {children}
        <Toaster />
      </AppProvider>
    </>
  );
}
